import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { resolveTabLocation } from '@/config/routeManifest'

/**
 * The active tab id, derived from the URL rather than from any stored value.
 * AppShellEffects writes the store in a useLayoutEffect (after commit), so a
 * stored value would lag the URL by one render. If `<Tabs value>` resolves to
 * undefined for even one render, Radix reverts to internal state and fires
 * onValueChange back to the previous tab — the Sessions-tab "URL flashes then
 * returns" regression. Memoized on the location identity: the chat-sidebar
 * resize drag re-renders the consumers at pointermove rate, and this must not
 * re-walk the route match every frame.
 */
export function useActiveTabId(): string | null {
  const location = useLocation()
  return useMemo(() => resolveTabLocation(location)?.id ?? null, [location])
}
